import { css } from '@emotion/react';
import { themeOld } from './theme';

export const InputStyle = (
	{
		block,
		danger,
		sizeLarge,
		sizeSmall,
		sizeMedium,
		ghost,
	}: {
		block?: boolean;
		danger?: boolean;
		sizeLarge?: boolean;
		sizeSmall?: boolean;
		sizeMedium?: boolean;
		ghost?: boolean;
	} = {
		block: false,
		danger: false,
		sizeLarge: false,
		sizeSmall: false,
		sizeMedium: false,
		ghost: false,
	},
) => css`
	border-radius: 4px;
	font-size: 14px;
	line-height: 20px;
	padding: 12px 16px;
	height: 40px;
	border: 0;

	transition: all 0.16s ease-in-out;

	${!ghost &&
	css`
		border: 1px solid ${themeOld.COLOR_DARK_GREEN_LIGHTEN_65};
	`};

	color: ${themeOld.COLOR_DARK_GREEN_DARKEN_6};

	&:hover {
		border-color: transparent;
		box-shadow: 0 0 0 2px ${themeOld.COLOR_DARK_GREEN_LIGHTEN_65};
		transition: all 0.2s ease-in-out;
	}

	&:focus {
		border-color: transparent;
		box-shadow: 0 0 0 2px ${themeOld.COLOR_DARK_GREEN_LIGHTEN_46};
		outline: none;
	}

	${!!sizeLarge &&
	css`
		padding: 12px 20px;
		height: 48px;
	`}

	${!!sizeMedium &&
	css`
		height: 36px;
	`}

	${!!sizeSmall &&
	css`
		padding: 8px 12px;
		height: 32px;
	`}

	${!!block &&
	css`
		width: 100%;
	`}

  ${!!danger &&
	css`
		&,
		&:hover,
		&:focus {
			border-color: ${themeOld.COLOR_BASE_RED};
		}

		&:hover,
		&:focus {
			border-color: transparent;
			box-shadow: 0 0 0 2px ${themeOld.COLOR_BASE_RED};
		}
	`}

  ::placeholder {
		color: ${themeOld.COLOR_DARK_GREEN_LIGHTEN_40};
	}
`;
